// refill endpoints
export const API_URL_REFILL_VERIFY_PHONE_NUMBER = "/shop/api/prepaid/verifyphonenumber";
export const API_URL_REFILL_SET_EMAIL = "/shop/api/prepaid/setemail";
export const API_URL_REFILL_SET_REFILL_OPTION = "/shop/api/prepaid/refilloption";
export const API_URL_REFILL_SUBMIT_ORDER = "/shop/api/prepaid/submitrefillorder";

// registration endpoints
export const API_URL_REGISTRATION_REGISTER_CARD = "/shop/api/prepaid/registercard";
export const API_URL_REGISTRATION_VERIFY_UPDATED_NAME = "/shop/api/prepaid/verifyupdatedname";
